import { useAPI } from "@/services/api";
import { useAnalytics } from "@Light/app/analytics";
import { Button } from "@Light/components/page/Button";
import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import { useHeaderFloating } from "@Light/components/page/header/context";
import { MutationButton } from "@Light/components/page/MutationButton";
import { PageBody } from "@Light/components/page/PageBody";
import { useScaffold } from "@Light/scaffold";
import { useSearchParams } from "@Light/utils/context";
import { STANDALONE_LOGIN_LINK_EXPIRATION } from "./constants";
import { useCountdown } from "./useCountdown";

export type CheckEmailProps = {};

export const CheckEmail: React.FC<CheckEmailProps> = ({}) => {
  const scaffold = useScaffold();
  const searchParams = useSearchParams()[0];
  const email = searchParams.get("email");
  const isSignup = searchParams.get("signup") === "true";

  const { useLoginEmailTokenMutation, useSignupMutation } = useAPI();
  const [loginEmailToken, loginEmailTokenState] = useLoginEmailTokenMutation();
  const [signup, signupState] = useSignupMutation();
  const { planUUID, attribution } = useAnalytics();
  const resendCountdown = useCountdown(30);

  useHeaderFloating(true);

  const resendEmail = () => {
    resendCountdown.restart();
    if (!email) {
      return;
    }
    if (isSignup) {
      signup({ email, plan: planUUID, attribution });
    } else {
      loginEmailToken({ email });
    }
  };

  const Link = scaffold.system.link;
  return (
    <PageBody
      title="Use the link we just emailed you to sign in"
      subtitle={`We emailed ${email ?? "you"} a login link to keep your account secure without a password. The link will expire in ${STANDALONE_LOGIN_LINK_EXPIRATION}.`}
      size="lg"
      centered
      footer={
        email ? (
          <ButtonFooter>
            <MutationButton
              type="button"
              size="md"
              buttonType="outline"
              mutation={isSignup ? signupState : loginEmailTokenState}
              mutate={resendEmail}
              disabled={resendCountdown.remaining > 0}
              mutateButtonText={
                resendCountdown.remaining > 0
                  ? `Resend email in ${resendCountdown.remaining}s`
                  : "Resend email"
              }
              errorMessage="We encountered an error while trying to resend the email. Please try again later."
            />
            <Link to="/login" className="w-full">
              <Button size="md" buttonType="clear" className="w-full">
                Use a different email
              </Button>
            </Link>
          </ButtonFooter>
        ) : (
          <ButtonFooter>
            <Link to="/login" className="w-full">
              <Button size="md" buttonType="outline" className="w-full">
                Back to login
              </Button>
            </Link>
          </ButtonFooter>
        )
      }
    />
  );
};
